export interface CircuitOpenPayload {
  circuit: string;
  from: string;
  to: string;
  reason: string;
  failureCount: number;
  timestamp: number;
  app?: string;
}

export type CircuitOpenNotifier = (payload: CircuitOpenPayload) => void;

const globalForNotifiers = globalThis as typeof globalThis & {
  sajilniCircuitOpenNotifiers?: CircuitOpenNotifier[];
};

function getNotifiers(): CircuitOpenNotifier[] {
  if (!globalForNotifiers.sajilniCircuitOpenNotifiers) {
    globalForNotifiers.sajilniCircuitOpenNotifiers = [];
  }
  return globalForNotifiers.sajilniCircuitOpenNotifiers;
}

export function registerCircuitOpenNotifier(
  notifier: CircuitOpenNotifier
): void {
  getNotifiers().push(notifier);
}

export function emitCircuitOpenAlert(
  circuit: string,
  from: string,
  to: string,
  reason: string,
  failureCount: number
): void {
  const payload: CircuitOpenPayload = {
    circuit,
    from,
    to,
    reason,
    failureCount,
    timestamp: Date.now(),
  };

  console.error("[circuit-breaker] Circuit opened", payload);

  for (const notifier of getNotifiers()) {
    try {
      notifier(payload);
    } catch (error) {
      console.error("[circuit-breaker] Notifier failed", {
        circuit,
        error,
      });
    }
  }
}
